export enum StorageName {
    drillings = 'drillings',
    projectreplies = 'projectreplies',
}
